import { render, staticRenderFns } from "./AppSearchPropertyItem.vue?vue&type=template&id=6a38e8a2&scoped=true&"
import script from "./AppSearchPropertyItem.vue?vue&type=script&lang=js&"
export * from "./AppSearchPropertyItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38e8a2",
  null
  
)

export default component.exports